import cookie from 'js/lib/cookie';
import pendo, { ENTERPRISE_API_KEY } from 'js/lib/pendo';
import user from 'js/lib/user';

/**
 * Init pendo.
 * This function should be called in `useEffects()` or `componentDidMount()`.
 */
export function initPendo() {
  if (typeof window === 'undefined') {
    return;
  }

  const { external_id: externalId, is_staff: isStaff, is_superuser: isSuperuser } = user.get();
  const sessionId = cookie.get('__204u');
  const isCourserian = user.isCourserian();

  let pageMetrics: { pageWidth: number; pageHeight: number } | undefined;
  if (typeof window !== 'undefined') {
    pageMetrics = {
      pageWidth: window.innerWidth,
      pageHeight: window.innerHeight,
    };
  }

  const visitorId = externalId || (sessionId as string);
  pendo.init(
    {
      visitor: {
        id: visitorId,
        isStaff: isStaff || false,
        isSuperuser: isSuperuser || false,
        isLoggedIn: user.isAuthenticatedUser(),
        ...pageMetrics,
        isCourserian,
      },
    },
    ENTERPRISE_API_KEY
  );
}
